<template>
    <div class="mt-2 ml-2">
        <b-form-checkbox
            @change="confirmarNaoAditivaretapa()"
            v-model="naoAditivar"
            :value="true"
            :unchecked-value="false"
        >
            <strong>Essa contratação não deve ser aditivada</strong>
        </b-form-checkbox>
    </div>
</template>

<script>
export default {
    props: {
        etapa: {
            type: Object,
            default: () => ({})
        },
        servicos: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            naoAditivar: false
        }
    },

    methods: {
        confirmarNaoAditivaretapa() {
            this.$swal({
                title: 'Etapa',
                html: `Confirma que a etapa <strong>${this.etapa.servico}</strong> ${this.naoAditivar ? 'poderá' : 'não deverá'} ser aditivada?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.naoAditivaretapa()
                } else {
                    this.naoAditivar = this.naoAditivar ? false : true
                }
            })
        },

        naoAditivaretapa() {
            this.$store.dispatch('addRequest')
            this.servicos.alterarNaoAditivar(this.etapa.etapaId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizar')
                        } else {
                            this.$toast.error(
                                'Erro ao alterar não aditivar etapa',
                                'ERROR',
                                this.$toastConfig.error
                            )
                            this.$emit('atualizar')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {
        this.naoAditivar = this.etapa.naoAditivar
    },

    computed: {},

    watch: {
        etapa() {
            this.naoAditivar = this.etapa.naoAditivar
        }
    },

    validations: {}
}
</script>
